import { Component } from '@angular/core';

@Component({
    template: ``
})
export class Configuration {

    public MainServer: string = 'http://localhost:53031/';  //local
    //public MainServer: string = 'http://api.inationaljetscafe.com/';  //stable
    //public MainServer: string = 'https://apix1cafestg.x1fbo.com/'; //staging
    //public MainServer: string = 'https://apinatjetscafe.x1fbo.com/';  //prod

    public ApiUrl: string = 'api/';
    public login: string = 'login';
    public token: string = 'token';
    public grant_type: string = 'password';
    public client_id: string = '224545s54e4v5478922';
    public ServerWithApiUrl = this.MainServer + this.ApiUrl;

    public msgTitles: string = 'POS';
    public ErrorMsg = {generalErrorMsg: "An error has occurred"};
    public actualModule: number = 0; // 1:Login,2:Home,3:Inventory,4Categories,5:Pos,6:Reports,7:Users,8:Settings
    public isLogged: boolean = false;
    public defaulTax: number = 0;

    public CustomerData = {CustomerName: null, IdBranch: null, IdUser: null, Tax: 0};

    constructor(){

    }
}



// WEBPACK FOOTER //
// ./src/constants/config.ts